import logo from "../../../theme/img/logo/logo2020-500.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {useTranslation} from "react-i18next";

export const PageLoader = () => {
    const { t } = useTranslation();
    return <div className="bg-white py-24 px-6 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
            <img src={logo} alt="logo" className={"w-40 mx-auto"} />
            <p className="mt-6 text-lg leading-8 text-gray-600">
                <FontAwesomeIcon icon={faCircleNotch} spin /> {t('booking.loading')}...
            </p>
        </div>
    </div>
}